const ERROR = {
  "4002": 'Invalid argument',
  "4005": 'Wrong username or password',
  '4006': 'Username or email has already been taken',
  '4008': 'Wrong MAC or SN'
}

export default ERROR
